import { render, staticRenderFns } from "./RspFormDinamicPQR.vue?vue&type=template&id=643c2f76"
import script from "./RspFormDinamicPQR.vue?vue&type=script&lang=js"
export * from "./RspFormDinamicPQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports